import movies from '../assets/movie.png';
import portfolio from '../assets/portfolio.png';

export const projects = [
    {
        id: 1,
        img: portfolio,
        name: "Simple React Portfolio",
        tech: "REACTJS | FRAMER-MOTION",
        about: "Simple and attractive personal portfolio using ReactJs",
        site: "https://sumitpandey.netlify.app",
        source: "https://github.com/Sumit063/portfolio"
    },
    {
        id: 2,
        img: movies,
        name: "HBO - Movie Mania",
        tech: "REACTJS | MATERIAL-UI",
        about: "ReactJs movie app that allows search movies and TV series",
        site: "https://hbomoviemania.netlify.app",
        source: "https://github.com/Sumit063/HBO-MovieMania"
    },
    {
        id: 2,
        name: "In-Progress",
        tech: "REACTJS",
        about: "Working on..",
        site: "NA",
        source: "NA"
    }
];